import { ResearchType } from './research-type.enum';

export const ProjectResearchLabel: Record<ResearchType, string> = {
  [ResearchType.AIInterview]: 'AI Interview',
  [ResearchType.DiscussionForum]: 'Discussion Forum',
  [ResearchType.Survey]: 'Survey',
  [ResearchType.FoodDiary]: 'Diary',
  [ResearchType.ExternalSurvey]: 'External Survey'
};
